import { useTranslation } from "react-i18next";
import { supportedLngs } from "@/i18n/config";
import { Globe } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "./select";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="w-[90px]">
      <Select
        value={i18n.language}
        onValueChange={changeLanguage}
      >
        <SelectTrigger className="h-8 text-sm border-none shadow-none px-1">
          <div className="flex items-center gap-1">
            <Globe size={16} />
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {Object.entries(supportedLngs).map(([code, { name }]) => (
            <SelectItem key={code} value={code} className="text-xs">
              {name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
